const countryList = [
    {name: 'Deutschland', wholeDay: 28, partialDay: 14, overnightRate: 20},
    {name: 'Ägypten', wholeDay: 50, partialDay: 33, overnightRate: 112},
    {name: 'Äthiopien', wholeDay: 44, partialDay: 29, overnightRate: 159},
    {name: 'Äquatorialguinea', wholeDay: 42, partialDay: 28, overnightRate: 166},
    {name: 'Albanien', wholeDay: 33, partialDay: 22, overnightRate: 116},
    {name: 'Algerien', wholeDay: 47, partialDay: 32, overnightRate: 120},
    {name: 'Andorra', wholeDay: 45, partialDay: 30, overnightRate: 135},
    {name: 'Angola', wholeDay: 40, partialDay: 27, overnightRate: 368},
    {name: 'Argentinien', wholeDay: 42, partialDay: 28, overnightRate: 119},
    {name: 'Armenien', wholeDay: 29, partialDay: 20, overnightRate: 107},
    {name: 'Aserbaidschan', wholeDay: 44, partialDay: 29, overnightRate: 88},
    {name: 'Australien', wholeDay: 57, partialDay: 38, overnightRate: 173},
    {name: 'Australien – Canberra', wholeDay: 74, partialDay: 49, overnightRate: 186},
    {name: 'Australien – Sydney', wholeDay: 57, partialDay: 38, overnightRate: 173},
    {name: 'Bahrain', wholeDay: 48, partialDay: 32, overnightRate: 153},
    {name: 'Bangladesch', wholeDay: 46, partialDay: 31, overnightRate: 189},
    {name: 'Barbados', wholeDay: 54, partialDay: 36, overnightRate: 206},
    {name: 'Belgien', wholeDay: 59, partialDay: 40, overnightRate: 141},
    {name: 'Benin', wholeDay: 40, partialDay: 27, overnightRate: 168},
    {name: 'Bhutan', wholeDay: 27, partialDay: 18, overnightRate: 176},
    {name: 'Bolivien', wholeDay: 46, partialDay: 31, overnightRate: 108},
    {name: 'Bosnien und Herzegowina', wholeDay: 32, partialDay: 21, overnightRate: 109},
    {name: 'Botsuana', wholeDay: 40, partialDay: 27, overnightRate: 105},
    {name: 'Brasilien', wholeDay: 46, partialDay: 31, overnightRate: 88},
    {name: 'Brasilien – Brasilia', wholeDay: 51, partialDay: 34, overnightRate: 88},
    {name: 'Brasilien – Rio de Janeiro', wholeDay: 69, partialDay: 46, overnightRate: 140},
    {name: 'Brasilien – Sao Paulo', wholeDay: 46, partialDay: 31, overnightRate: 151},
    {name: 'Brunei', wholeDay: 45, partialDay: 30, overnightRate: 110},
    {name: 'Bulgarien', wholeDay: 38, partialDay: 25, overnightRate: 109},
    {name: 'Burkina Faso', wholeDay: 39, partialDay: 26, overnightRate: 230},
    {name: 'Burundi', wholeDay: 58, partialDay: 39, overnightRate: 102},
    {name: 'Chile', wholeDay: 44, partialDay: 29, overnightRate: 154},
    {name: 'China', wholeDay: 48, partialDay: 32, overnightRate: 142},
    {name: 'China – Hongkong', wholeDay: 83, partialDay: 56, overnightRate: 209},
    {name: 'China – Peking', wholeDay: 57, partialDay: 38, overnightRate: 184},
    {name: 'China – Shanghai', wholeDay: 48, partialDay: 32, overnightRate: 142},
    {name: 'Costa Rica', wholeDay: 60, partialDay: 40, overnightRate: 127},
    {name: 'Côte d’Ivoire(Elfenbeinküste)', wholeDay: 60, partialDay: 40, overnightRate: 171},
    {name: 'Dänemark', wholeDay: 75, partialDay: 50, overnightRate: 183},
    {name: 'Dominikanische Republik', wholeDay: 50, partialDay: 33, overnightRate: 167},
    {name: 'Dschibuti', wholeDay: 77, partialDay: 52, overnightRate: 255},
    {name: 'Ecuador', wholeDay: 27, partialDay: 18, overnightRate: 103},
    {name: 'El Salvador', wholeDay: 65, partialDay: 44, overnightRate: 161},
    {name: 'Eritrea', wholeDay: 46, partialDay: 31, overnightRate: 78},
    {name: 'Estland', wholeDay: 39, partialDay: 26, overnightRate: 125},
    {name: 'Fidschi', wholeDay: 32, partialDay: 21, overnightRate: 183},
    {name: 'Finnland', wholeDay: 54, partialDay: 36, overnightRate: 171},
    {name: 'Frankreich', wholeDay: 53, partialDay: 36, overnightRate: 105},
    {name: 'Frankreich – Paris sowie die Departements 77, 78, 91 bis 95', wholeDay: 58, partialDay: 39, overnightRate: 159},
    {name: 'Gabun', wholeDay: 64, partialDay: 43, overnightRate: 263},
    {name: 'Gambia', wholeDay: 40, partialDay: 27, overnightRate: 161},
    {name: 'Georgien', wholeDay: 45, partialDay: 30, overnightRate: 87},
    {name: 'Ghana', wholeDay: 46, partialDay: 31, overnightRate: 203},
    {name: 'Griechenland', wholeDay: 36, partialDay: 24, overnightRate: 150},
    {name: 'Griechenland – Athen', wholeDay: 40, partialDay: 27, overnightRate: 139},
    {name: 'Guatemala', wholeDay: 46, partialDay: 31, overnightRate: 124},
    {name: 'Guinea', wholeDay: 59, partialDay: 40, overnightRate: 140},
    {name: 'Guinea-Bissau', wholeDay: 32, partialDay: 21, overnightRate: 113},
    {name: 'Haiti', wholeDay: 58, partialDay: 39, overnightRate: 130},
    {name: 'Honduras', wholeDay: 57, partialDay: 38, overnightRate: 198},
    {name: 'Indien', wholeDay: 22, partialDay: 15, overnightRate: 80},
    {name: 'Indien – Bangalore', wholeDay: 42, partialDay: 28, overnightRate: 155},
    {name: 'Indien – Chennai', wholeDay: 22, partialDay: 15, overnightRate: 80},
    {name: 'Indien – Kalkutta', wholeDay: 32, partialDay: 21, overnightRate: 167},
    {name: 'Indien – Mumbai', wholeDay: 53, partialDay: 36, overnightRate: 218},
    {name: 'Indien – Neu Dehli', wholeDay: 46, partialDay: 31, overnightRate: 211},
    {name: 'Indonesien', wholeDay: 45, partialDay: 30, overnightRate: 179},
    {name: 'Iran', wholeDay: 33, partialDay: 22, overnightRate: 196},
    {name: 'Irland', wholeDay: 64, partialDay: 43, overnightRate: 164},
    {name: 'Island', wholeDay: 62, partialDay: 41, overnightRate: 187},
    {name: 'Israel', wholeDay: 59, partialDay: 40, overnightRate: 268},
    {name: 'Italien', wholeDay: 42, partialDay: 28, overnightRate: 150},
    {name: 'Italien – Mailand', wholeDay: 42, partialDay: 28, overnightRate: 191},
    {name: 'Italien – Rom', wholeDay: 48, partialDay: 32, overnightRate: 150},
    {name: 'Jamaika', wholeDay: 39, partialDay: 26, overnightRate: 171},
    {name: 'Japan', wholeDay: 33, partialDay: 22, overnightRate: 141},
    {name: 'Japan – Tokio', wholeDay: 50, partialDay: 33, overnightRate: 285},
    {name: 'Japan – Osaka', wholeDay: 33, partialDay: 22, overnightRate: 141},
    {name: 'Jordanien', wholeDay: 57, partialDay: 38, overnightRate: 134},
    {name: 'Kambodscha', wholeDay: 42, partialDay: 28, overnightRate: 108},
    {name: 'Kamerun', wholeDay: 56, partialDay: 37, overnightRate: 275},
    {name: 'Kanada', wholeDay: 54, partialDay: 36, overnightRate: 214},
    {name: 'Kanada – Ottawa', wholeDay: 62, partialDay: 41, overnightRate: 214},
    {name: 'Kanada – Toronto', wholeDay: 54, partialDay: 36, overnightRate: 392},
    {name: 'Kanada – Vancouver', wholeDay: 63, partialDay: 42, overnightRate: 304},
    {name: 'Kap Verde', wholeDay: 38, partialDay: 25, overnightRate: 90},
    {name: 'Kasachstan', wholeDay: 33, partialDay: 22, overnightRate: 108},
    {name: 'Katar', wholeDay: 81, partialDay: 54, overnightRate: 128},
    {name: 'Kenia', wholeDay: 48, partialDay: 32, overnightRate: 217},
    {name: 'Kirgisistan', wholeDay: 35, partialDay: 24, overnightRate: 80},
    {name: 'Kolumbien', wholeDay: 34, partialDay: 23, overnightRate: 123},
    {name: 'Kongo, Republik', wholeDay: 53, partialDay: 36, overnightRate: 215},
    {name: 'Kongo, Demokratische Republik', wholeDay: 65, partialDay: 44, overnightRate: 337},
    {name: 'Korea, Republik', wholeDay: 39, partialDay: 26, overnightRate: 130},
    {name: 'Kosovo', wholeDay: 24, partialDay: 16, overnightRate: 71},
    {name: 'Kroatien', wholeDay: 46, partialDay: 31, overnightRate: 191},
    {name: 'Kuba', wholeDay: 51, partialDay: 34, overnightRate: 170},
    {name: 'Kuwait', wholeDay: 63, partialDay: 42, overnightRate: 224},
    {name: 'Laos', wholeDay: 35, partialDay: 24, overnightRate: 71},
    {name: 'Lesotho', wholeDay: 28, partialDay: 19, overnightRate: 104},
    {name: 'Lettland', wholeDay: 46, partialDay: 31, overnightRate: 119},
    {name: 'Libanon', wholeDay: 69, partialDay: 46, overnightRate: 146},
    {name: 'Liberia', wholeDay: 65, partialDay: 44, overnightRate: 173},
    {name: 'Liechtenstein', wholeDay: 57, partialDay: 38, overnightRate: 234},
    {name: 'Litauen', wholeDay: 48, partialDay: 32, overnightRate: 124},
    {name: 'Luxemburg', wholeDay: 63, partialDay: 42, overnightRate: 139},
    {name: 'Madagaskar', wholeDay: 33, partialDay: 22, overnightRate: 116},
    {name: 'Malawi', wholeDay: 41, partialDay: 28, overnightRate: 109},
    {name: 'Malaysia', wholeDay: 36, partialDay: 24, overnightRate: 86},
    {name: 'Malediven', wholeDay: 70, partialDay: 47, overnightRate: 200},
    {name: 'Mali', wholeDay: 42, partialDay: 28, overnightRate: 141},
    {name: 'Malta', wholeDay: 59, partialDay: 40, overnightRate: 191},
    {name: 'Marokko', wholeDay: 41, partialDay: 28, overnightRate: 87},
    {name: 'Marshall Inseln', wholeDay: 45, partialDay: 30, overnightRate: 112},
    {name: 'Mauretanien', wholeDay: 35, partialDay: 24, overnightRate: 86},
    {name: 'Mauritius', wholeDay: 44, partialDay: 29, overnightRate: 172},
    {name: 'Mexiko', wholeDay: 40, partialDay: 27, overnightRate: 337},
    {name: 'Moldau, Republik', wholeDay: 26, partialDay: 17, overnightRate: 73},
    {name: 'Monaco', wholeDay: 52, partialDay: 35, overnightRate: 187},
    {name: 'Mongolei', wholeDay: 23, partialDay: 16, overnightRate: 92},
    {name: 'Montenegro', wholeDay: 32, partialDay: 21, overnightRate: 85},
    {name: 'Mosambik', wholeDay: 51, partialDay: 34, overnightRate: 208},
    {name: 'Myanmar', wholeDay: 23, partialDay: 16, overnightRate: 103},
    {name: 'Namibia', wholeDay: 28, partialDay: 19, overnightRate: 146},
    {name: 'Nepal', wholeDay: 33, partialDay: 22, overnightRate: 125},
    {name: 'Neuseeland', wholeDay: 58, partialDay: 39, overnightRate: 148},
    {name: 'Nicaragua', wholeDay: 46, partialDay: 31, overnightRate: 105},
    {name: 'Niederlande', wholeDay: 58, partialDay: 39, overnightRate: 167},
    {name: 'Niger', wholeDay: 42, partialDay: 28, overnightRate: 131},
    {name: 'Nigeria', wholeDay: 52, partialDay: 35, overnightRate: 202},
    {name: 'Nordmazedonien', wholeDay: 27, partialDay: 18, overnightRate: 89},
    {name: 'Norwegen', wholeDay: 75, partialDay: 50, overnightRate: 139},
    {name: 'Österreich', wholeDay: 50, partialDay: 33, overnightRate: 117},
    {name: 'Oman', wholeDay: 64, partialDay: 43, overnightRate: 141},
    {name: 'Pakistan', wholeDay: 41, partialDay: 28, overnightRate: 199},
    {name: 'Palau', wholeDay: 51, partialDay: 34, overnightRate: 193},
    {name: 'Panama', wholeDay: 41, partialDay: 28, overnightRate: 82},
    {name: 'Papua-Neuguinea', wholeDay: 59, partialDay: 40, overnightRate: 159},
    {name: 'Paraguay', wholeDay: 39, partialDay: 26, overnightRate: 124},
    {name: 'Peru', wholeDay: 52, partialDay: 35, overnightRate: 128},
    {name: 'Philippinen[3]', wholeDay: 41, partialDay: 28, overnightRate: 140},
    {name: 'Polen', wholeDay: 34, partialDay: 23, overnightRate: 124},
    {name: 'Polen – Breslau', wholeDay: 34, partialDay: 23, overnightRate: 124},
    {name: 'Polen – Warschau', wholeDay: 40, partialDay: 27, overnightRate: 143},
    {name: 'Portugal', wholeDay: 32, partialDay: 21, overnightRate: 111},
    {name: 'Ruanda', wholeDay: 44, partialDay: 29, overnightRate: 117},
    {name: 'Rumänien', wholeDay: 38, partialDay: 25, overnightRate: 103},
    {name: 'Russische Föderation', wholeDay: 28, partialDay: 19, overnightRate: 133},
    {name: 'Russische Föderation – Moskau', wholeDay: 30, partialDay: 20, overnightRate: 235},
    {name: 'Russische Föderation – St. Petersburg', wholeDay: 28, partialDay: 19, overnightRate: 133},
    {name: 'Sambia', wholeDay: 38, partialDay: 25, overnightRate: 105},
    {name: 'Samoa', wholeDay: 39, partialDay: 26, overnightRate: 105},
    {name: 'San Marino', wholeDay: 34, partialDay: 23, overnightRate: 79},
    {name: 'Sao Tomé – Principe', wholeDay: 36, partialDay: 24, overnightRate: 147},
    {name: 'Saudi-Arabien', wholeDay: 56, partialDay: 37, overnightRate: 181},
    {name: 'Saudi-Arabien – Djidda', wholeDay: 57, partialDay: 38, overnightRate: 181},
    {name: 'Saudi-Arabien – Riad', wholeDay: 56, partialDay: 37, overnightRate: 186},
    {name: 'Schweden', wholeDay: 66, partialDay: 44, overnightRate: 140},
    {name: 'Schweiz', wholeDay: 70, partialDay: 47, overnightRate: 195},
    {name: 'Schweiz – Bern', wholeDay: 82, partialDay: 55, overnightRate: 195},
    {name: 'Schweiz – Genf', wholeDay: 70, partialDay: 47, overnightRate: 197},
    {name: 'Senegal', wholeDay: 48, partialDay: 32, overnightRate: 160},
    {name: 'Serbien', wholeDay: 27, partialDay: 18, overnightRate: 97},
    {name: 'Sierra Leone', wholeDay: 57, partialDay: 38, overnightRate: 145},
    {name: 'Simbabwe', wholeDay: 63, partialDay: 42, overnightRate: 198},
    {name: 'Singapur', wholeDay: 71, partialDay: 48, overnightRate: 277},
    {name: 'Slowakische Republik', wholeDay: 33, partialDay: 22, overnightRate: 121},
    {name: 'Slowenien', wholeDay: 38, partialDay: 25, overnightRate: 126},
    {name: 'Spanien', wholeDay: 34, partialDay: 23, overnightRate: 103},
    {name: 'Spanien – Barcelona', wholeDay: 34, partialDay: 23, overnightRate: 144},
    {name: 'Spanien – Kanarische Inseln', wholeDay: 36, partialDay: 24, overnightRate: 103},
    {name: 'Spanien – Madrid', wholeDay: 42, partialDay: 28, overnightRate: 131},
    {name: 'Spanien – Mallorca', wholeDay: 44, partialDay: 29, overnightRate: 142},
    {name: 'Sri Lanka', wholeDay: 36, partialDay: 24, overnightRate: 112},
    {name: 'Sudan', wholeDay: 33, partialDay: 22, overnightRate: 195},
    {name: 'Südafrika', wholeDay: 29, partialDay: 20, overnightRate: 109},
    {name: 'Südafrika – Kapstadt', wholeDay: 33, partialDay: 22, overnightRate: 130},
    {name: 'Südafrika – Johannisburg', wholeDay: 36, partialDay: 24, overnightRate: 129},
    {name: 'Südsudan', wholeDay: 51, partialDay: 34, overnightRate: 159},
    {name: 'Tadschikistan', wholeDay: 27, partialDay: 18, overnightRate: 85},
    {name: 'Taiwan', wholeDay: 51, partialDay: 34, overnightRate: 174},
    {name: 'Tansania', wholeDay: 44, partialDay: 29, overnightRate: 97},
    {name: 'Thailand', wholeDay: 36, partialDay: 24, overnightRate: 114},
    {name: 'Togo', wholeDay: 36, partialDay: 24, overnightRate: 144},
    {name: 'Tonga', wholeDay: 29, partialDay: 20, overnightRate: 102},
    {name: 'Trinidad und Tobago[4]', wholeDay: 66, partialDay: 44, overnightRate: 203},
    {name: 'Tschad', wholeDay: 42, partialDay: 28, overnightRate: 155},
    {name: 'Tschechische Republik', wholeDay: 32, partialDay: 21, overnightRate: 77},
    {name: 'Türkei', wholeDay: 24, partialDay: 16, overnightRate: 107},
    {name: 'Türkei – Ankara', wholeDay: 32, partialDay: 21, overnightRate: 110},
    {name: 'Türkei – Izmir', wholeDay: 44, partialDay: 29, overnightRate: 120},
    {name: 'Tunesien', wholeDay: 40, partialDay: 27, overnightRate: 144},
    {name: 'Turkmenistan', wholeDay: 28, partialDay: 19, overnightRate: 135},
    {name: 'Uganda', wholeDay: 45, partialDay: 30, overnightRate: 207},
    {name: 'Ukraine', wholeDay: 33, partialDay: 22, overnightRate: 180},
    {name: 'Ungarn', wholeDay: 32, partialDay: 21, overnightRate: 85},
    {name: 'Uruguay', wholeDay: 40, partialDay: 27, overnightRate: 113},
    {name: 'Usbekistan', wholeDay: 32, partialDay: 21, overnightRate: 133},
    {name: 'Vatikanstaat', wholeDay: 48, partialDay: 32, overnightRate: 150},
    {name: 'Venezuela', wholeDay: 51, partialDay: 34, overnightRate: 178},
    {name: 'Vereinigte Arabische Emirate', wholeDay: 81, partialDay: 54, overnightRate: 169},
    {name: 'Vereinigte Staaten von Amerika (USA)', wholeDay: 59, partialDay: 40, overnightRate: 182},
    {name: 'Vereinigte Staaten von Amerika (USA) – Atlanta', wholeDay: 77, partialDay: 52, overnightRate: 182},
    {name: 'Vereinigte Staaten von Amerika (USA) – Boston', wholeDay: 63, partialDay: 42, overnightRate: 333},
    {name: 'Vereinigte Staaten von Amerika (USA) – Chicago', wholeDay: 65, partialDay: 44, overnightRate: 233},
    {name: 'Vereinigte Staaten von Amerika (USA) – Houston', wholeDay: 62, partialDay: 41, overnightRate: 204},
    {name: 'Vereinigte Staaten von Amerika (USA) – Los Angeles', wholeDay: 64, partialDay: 43, overnightRate: 262},
    {name: 'Vereinigte Staaten von Amerika (USA) – Miami', wholeDay: 65, partialDay: 44, overnightRate: 256},
    {name: 'Vereinigte Staaten von Amerika (USA) – New York City', wholeDay: 66, partialDay: 44, overnightRate: 308},
    {name: 'Vereinigte Staaten von Amerika (USA) – San Francisco', wholeDay: 59, partialDay: 40, overnightRate: 327},
    {name: 'Vereinigte Staaten von Amerika (USA) – Washington, D.C.', wholeDay: 66, partialDay: 44, overnightRate: 203},
    {name: 'Vereinigtes Königreich von Großbritannien und Nordirland', wholeDay: 52, partialDay: 35, overnightRate: 99},
    {name: 'Vereinigtes Königreich von Großbritannien – London', wholeDay: 66, partialDay: 44, overnightRate: 163},
    {name: 'Vietnam', wholeDay: 36, partialDay: 24, overnightRate: 111},
    {name: 'Weißrussland', wholeDay: 21, partialDay: 14, overnightRate: 148},
    {name: 'Zentralafrikanische Republik', wholeDay: 53, partialDay: 36, overnightRate: 210},
    {name: 'Zypern', wholeDay: 42, partialDay: 28, overnightRate: 125},

];

export default countryList;